"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getToken = exports.getTokenCookieName = exports.decodeToken = void 0;
var cookies_1 = __importDefault(require("./cookies"));
var guards_1 = require("./guards");
var types_1 = require("./types");
var window_1 = require("./window");
var urlBase64Decode = function (str) {
    var output = str.replace(/-/g, '+').replace(/_/g, '/');
    switch (output.length % 4) {
        case 0:
            break;
        case 2:
            output += '==';
            break;
        case 3:
            output += '=';
            break;
        default:
            // tslint:disable-next-line:no-string-throw
            throw 'Illegal base64url string!';
    }
    return decodeURIComponent(window.escape(window.atob(output)));
};
/**
 * Decodes given token
 * @param token
 * @returns decoded token
 * * @throws exception in case of:
 * - Length !== 3
 * - Cannot be decoded to base64
 */
var decodeToken = function (token) {
    if (token === void 0) { token = ''; }
    if (token === null || token === '') {
        return { upn: '' };
    }
    var parts = token.split('.');
    if (parts.length !== 3) {
        throw new Error('JWT must have 3 parts');
    }
    var decoded = urlBase64Decode(parts[1]);
    if (!decoded) {
        throw new Error('Cannot decode the token');
    }
    return JSON.parse(decoded);
};
exports.decodeToken = decodeToken;
var authTokenUrlParam = 'access_token';
var getTokenCookieName = function (token_type, environment, isMasqueraded) {
    switch (environment) {
        case 'production':
            return "".concat(token_type, "_gwi").concat(isMasqueraded ? '_masquerading' : '');
        case 'staging':
            return "".concat(token_type, "_gwi_staging").concat(isMasqueraded ? '_masquerading' : '');
        case 'testing':
            return "".concat(token_type, "_gwi_testing").concat(isMasqueraded ? '_masquerading' : '');
        case 'development':
            return "".concat(token_type, "_gwi_testing").concat(isMasqueraded ? '_masquerading' : '');
        default:
            throw "Unknown environment: \"".concat(environment, "\"!");
    }
};
exports.getTokenCookieName = getTokenCookieName;
/**
 * Gets user token depending on the enviroment passed
 * @param environment
 * @returns token string
 */
var getToken = function (environment, type) {
    var params = window_1.UrlManager.parseParams();
    var urlToken = params[authTokenUrlParam] && decodeURIComponent(params[authTokenUrlParam]);
    var cookie = new cookies_1.default(null);
    var cookieName = (0, exports.getTokenCookieName)(type !== null && type !== void 0 ? type : types_1.TokenType.Authorization, environment); // cookiePrefix + (environment !== EnvironmentEnum.Production ? `_${environment}` : '');
    var cookieNameMasquarade = "".concat(cookieName, "_masquerading");
    if (urlToken) {
        cookie.write(cookieName, urlToken);
        var urlWithoutToken = window_1.UrlManager.removeURLParameter(window.location.href, authTokenUrlParam);
        window.history.pushState({}, document.title, urlWithoutToken);
        return urlToken;
    }
    if (!(0, guards_1.isUndefinedOrNullOrEmptyString)(cookie.read(cookieNameMasquarade))) {
        return cookie.read(cookieNameMasquarade);
    }
    else if (!(0, guards_1.isUndefinedOrNullOrEmptyString)(cookie.read(cookieName))) {
        return cookie.read(cookieName);
    }
    else {
        return '';
    }
};
exports.getToken = getToken;
